/* -*- Mode: javascript; indent-tabs-mode: nil; c-basic-offset: 2 -*- */

/**
 * range - A simple filter that will return an array of the size of its argument.
 * @memberof SOGo.Common
 */
(function () {
  'use strict';

  function last() {
    return function(a) {
      return _.last(a);
    };
  }

  angular.module('SOGo.Common')
    .filter('last', last);
})();
